import type { EventDoc } from 'types/api/changes'

import { dateInTimezone, getDefaultTimezone, resolveTimezone } from './timezone'

// All-day dates retain the zone in which their calendar date was stored.
export function eventDisplayDate(
  event: EventDoc,
  timestamp: string | undefined,
  timeZone = getDefaultTimezone()
) {
  return dateInTimezone(
    Number(timestamp) * 1000,
    event.AllDay === '1'
      ? resolveTimezone(event.TimeZoneNameID, timeZone)
      : timeZone
  )
}

// Events without an end are single-date events, matching the calendar mapper.
export function eventEndTimestamp(event: EventDoc): string | undefined {
  return event.EndDate == null ||
    event.EndDate === '' ||
    event.EndDate === 'null'
    ? event.StartDate
    : event.EndDate
}
